import React, { useState } from 'react';
import { sendSupportMessage } from '../api/api'; // Assurez-vous d'ajouter cette fonction dans votre api.js
import styles from './SupportPage.module.css';

const SupportPage = () => {
    const [formData, setFormData] = useState({
        type: 'Demande de Rendez-vous',
        message: ''
    });
    const [status, setStatus] = useState({ loading: false, success: false, error: null });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, success: false, error: null });

        try {
            await sendSupportMessage(formData);
            setStatus({ loading: false, success: true, error: null });
            setFormData({ type: 'Demande de Rendez-vous', message: '' }); // Reset
        } catch (err) {
            setStatus({ loading: false, success: false, error: "Une erreur est survenue lors de l'envoi." });
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h1 className={styles.title}>📞 Support & Rendez-vous</h1>
                <p className={styles.subtitle}>
                    Une question sur votre fiche de paie ? Besoin d'un point de carrière ? 
                    Envoyez-nous un message directement ici.
                </p>

                {status.success && (
                    <div className={styles.alertSuccess}>
                        ✅ Votre message a bien été envoyé ! Nous vous répondrons rapidement.
                    </div>
                )}

                {status.error && (
                    <div className={styles.alertError}>
                        ❌ {status.error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.formGroup}>
                        <label htmlFor="type">Objet de votre demande</label>
                        <select 
                            name="type" 
                            id="type" 
                            value={formData.type} 
                            onChange={handleChange}
                            className={styles.select}
                        >
                            <option value="Demande de Rendez-vous">📅 Demande de Rendez-vous</option>
                            <option value="Question Facturation / Paie">💰 Question Facturation / Paie</option>
                            <option value="Problème Technique">🛠️ Problème Technique</option>
                            <option value="Autre">📝 Autre demande</option>
                        </select>
                    </div>

                    <div className={styles.formGroup}>
                        <label htmlFor="message">Votre message</label>
                        <textarea 
                            name="message" 
                            id="message" 
                            rows="6" 
                            placeholder="Bonjour, je souhaiterais faire un point sur..."
                            value={formData.message}
                            onChange={handleChange}
                            required
                            className={styles.textarea}
                        ></textarea>
                    </div>

                    <button 
                        type="submit" 
                        className={styles.submitBtn}
                        disabled={status.loading}
                    >
                        {status.loading ? 'Envoi en cours...' : 'Envoyer la demande'}
                    </button>
                </form>
            </div>
            
            {/* Info Box */}
            <div className={styles.infoBox}>
                <p>💡 <strong>Bon à savoir :</strong> Pour les urgences administratives, vous pouvez aussi contacter directement votre manager par téléphone.</p>
            </div>
        </div>
    );
};

export default SupportPage;